import * as React from "react"

export default class Form extends React.Component{
    render(){
        return (
            <form className="form-horizontal">
                {this.props.children}
            </form>
        )
    }
}